import { ModelResId } from '@/store/creative/model-editor/index.type'
import { ModelMaterial } from '@/types/dmaker/category.type'

// 为了区分 gameConfig 的描述和选项，需要加特殊前缀
export const SPEC_PREFIX_MODEL = 'MODEL_' // 模型相关参数
export const SPEC_SEP = '_$$_' // 特殊分隔符，避免遇到动态参数命名一致导致解析错误
export const SPEC_PREFIX_CONFIG = 'CONFIG_'
export const SPEC_PREFIX_DESC = 'CONFIG_DESC_'
export const SPEC_PREFIX_OPTIONS = 'CONFIG_OPTIONS_'
export const SPEC_PREFIX_UNIT = 'CONFIG_UNIT_'
export const SPEC_PS_PREFIX = 'PS_EDITOR_'
export const SPEC_PREFIX_PRESET_OPTIONS = 'PRESET_OPTIONS_'
export const SPEC_PREFIX_CAMERA = 'CAMERA_'

export const I18nKeyManager = {
  camera: {
    encode: (index: number): string => {
      return `${SPEC_PREFIX_CAMERA}${index}`
    },
    decode: (key: string): number => {
      return Number(key.replace(SPEC_PREFIX_CAMERA, ''))
    },
    has: (key: string): boolean => key.startsWith(SPEC_PREFIX_CAMERA),
  },
  model: {
    encode: (
      categoryId: string,
      modelId: ModelResId,
      modelKey: typeof ModelMaterial,
    ): string => {
      return `${SPEC_PREFIX_MODEL}${categoryId}${SPEC_SEP}${JSON.stringify(
        modelId,
      )}${SPEC_SEP}${modelKey}`
    },
    decode: (
      key: string,
    ): {
      categoryId: string
      modelId: ModelResId
      modelKey: typeof ModelMaterial
    } => {
      const [categoryId, modelId, modelKey] = key
        .replace(SPEC_PREFIX_MODEL, '')
        .split(SPEC_SEP)
      return {
        categoryId,
        modelId: JSON.parse(modelId),
        modelKey: modelKey as keyof ModelMaterial,
      }
    },
    has: (key: string): boolean => key.startsWith(SPEC_PREFIX_MODEL),
  },
}
